import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatTabsModule } from '@angular/material/tabs';
import { RouterModule } from '@angular/router';
import { AuthGuard, CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { PageSlotModule } from '@spartacus/storefront';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbWarrantyLandingPageComponent } from './kb-warranty-landing-page/kb-warranty-landing-page.component';
import { QuickCoverageGuideComponent } from './quick-coverage-guide/quick-coverage-guide.component';
import { ShippingPackagingComponent } from './shipping-packaging/shipping-packaging.component';
import { WarrantyDocumentsComponent } from './warranty-documents/warranty-documents.component';
import { WarrantyEligibleCheckComponent } from './warranty-eligible-check/warranty-eligible-check.component';
import { WarrantyTabsComponent } from './warranty-tabs/warranty-tabs.component';
import { WarrantyTermsComponent } from './warranty-terms/warranty-terms.component';
import { WarrantyParagraphComponent } from './warranty-paragraph/warranty-paragraph.component';
import { KbWarrantyLandingPageParagraphComponent } from './kb-warranty-landing-page-paragraph/kb-warranty-landing-page-paragraph.component';
@NgModule({
  declarations: [
    KbWarrantyLandingPageComponent,
    WarrantyEligibleCheckComponent,
    WarrantyTermsComponent,
    WarrantyTabsComponent,
    WarrantyDocumentsComponent,
    ShippingPackagingComponent,
    QuickCoverageGuideComponent,
    WarrantyParagraphComponent,
    KbWarrantyLandingPageParagraphComponent,
  ],
  imports: [
    CommonModule,
    I18nModule,
    RouterModule,
    UrlModule,
    MatTabsModule,
    TabsModule,
    AccordionModule,
    ReactiveFormsModule,
    PageSlotModule,
    BsDatepickerModule,
    ConfigModule.withConfig({
      cmsComponents: {
        MyWarrantiesFlexComponent: {
          component: KbWarrantyLandingPageComponent,
          guards: [SecureGuard],
        },
        WarrantyInfoFlexComponent: {
          component: WarrantyParagraphComponent,
          guards: [SecureGuard],
        },
        WarrantyInfoPageFlexComponent: {
          component: KbWarrantyLandingPageParagraphComponent,
          guards: [SecureGuard],
        }
      },
    } as CmsConfig),
  ],
})
export class KbWarrantyModule { }
